"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcCollectionCost = exports.isInsideTagInterval = exports.postProcessing = exports.getDeposits = void 0;
const moment_1 = __importDefault(require("moment"));
const __1 = require("../..");
const vouchers_1 = require("../vouchers");
const denmark_1 = require("./collection-costs/denmark");
const greenland_1 = require("./collection-costs/greenland");
const getDeposits = (caseVouchers) => {
    return caseVouchers.filter((v) => {
        return v.voucherTypeId === vouchers_1.VoucherTypeIds.DEPOSIT && v.amount !== 0;
    });
};
exports.getDeposits = getDeposits;
const postProcessing = (caseVouchers, filter) => {
    caseVouchers = caseVouchers.map((voucher) => {
        if (voucher.expired || voucher.irrecoverableDate) {
            voucher.originalAmount = voucher.originalAmount || voucher.amount;
            voucher.amount = 0;
        }
        return voucher;
    });
    if (!filter.includeDeletedVouchers) {
        caseVouchers = caseVouchers.filter((voucher) => ((voucher.details && voucher.details.deletingVoucherId) ||
            caseVouchers.find((v) => (v.details && v.details.deletingVoucherId) ===
                voucher.caseVoucherId && v.amount === -voucher.amount)) == null);
    }
    if (!filter.includeExpiredVouchers) {
        caseVouchers = caseVouchers.filter((voucher) => !voucher.expired);
    }
    if (!filter.includeIrrecoverableVouchers) {
        caseVouchers = caseVouchers.filter((voucher) => !voucher.irrecoverableDate);
    }
    return caseVouchers;
};
exports.postProcessing = postProcessing;
const isInsideTagInterval = (tag, date) => {
    const _date = (0, moment_1.default)(date);
    return (tag &&
        (!tag.from || (0, moment_1.default)(tag.from).isBefore(_date)) &&
        (!tag.to || (0, moment_1.default)(tag.to).isAfter(_date)));
};
exports.isInsideTagInterval = isInsideTagInterval;
const calcCollectionCost = (caseVouchers, documents, expirationSettings, selfCollection, country) => {
    switch (country) {
        case __1.CountryCode.GL: {
            return (0, greenland_1.calcCollectionCosts)(caseVouchers, documents, expirationSettings, selfCollection);
        }
        case __1.CountryCode.DK: {
            return (0, denmark_1.calcCollectionCosts)(caseVouchers, documents, expirationSettings, selfCollection);
        }
        default: {
            return (0, denmark_1.calcCollectionCosts)(caseVouchers, documents, expirationSettings, selfCollection);
        }
    }
};
exports.calcCollectionCost = calcCollectionCost;
//# sourceMappingURL=vouchers.js.map